import basicController from "servicestack/basic.controller.properties";
import $resolve from "ng";
import modals from "webmodals/modals";
import ServiceBus from 'servicestack/service-bus'

export default class TransferGoalsController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
	$ctrl.bus = $ctrl.$session.bus;
    $ctrl.title = "Transfer Goals...";
 	$ctrl.request = {
		OldRep: "",
		NewRep: ""
	};
    $ctrl.submit = () => {
		$ctrl.transferCompleted = false;
		$ctrl.bus.send("TransferSalesGoals.json", $ctrl.request).then(res => {
			$ctrl.transferCompleted = true;
		});
    };
  }
  findReps(val) {
    let $ctrl = this;
    let url = `QuerySalesReps.json?Take=15&JsConfig=ExcludeDefaultValues&Search=${val}&OrderBy=Id`; //
    return $ctrl.bus.send(url).then(res => res.data.results);
  }
  setOldRep(rep) {
    const $ctrl = this;
    if (!rep) rep = {};
    $ctrl.request.OldRep = rep.id;
  }
  setNewRep(rep) {
    const $ctrl = this;
    if (!rep) rep = {};
    $ctrl.request.NewRep = rep.id;
  }

}
